/* eslint-disable @typescript-eslint/no-unused-vars */

xplenty.directive('componentEditorFacebookSource', [
  '$location',

  function ($location) {
    return {
      controller: 'ComponentEditorFacebookSourceController',

      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./_component-editor-facebook-source.html'),

      replace: true,

      link(scope, element, attrs) {},
    };
  },
]);
